// extracted by mini-css-extract-plugin
export default {"panel":"Search_panel__94Qb6","submit":"Search_submit__RoLMb","btn":"Search_btn__dX9KZ"};